module.exports = __webpack_public_path__ + "img/1202.82550f34.jpg";